import { getArrow } from 'perfect-arrows';

import { RenderArrowProps } from './types';

export const renderArrow = ({
  leftId,
  rightId,
  containerEl,
  color,
  strokeWidth = 2,
  showDot = false,
  showArrowHead = false,
}: RenderArrowProps) => {
  const leftElement = document.querySelector(`[data-mtf-id="${leftId}"]`);
  const rightElement = document.querySelector(`[data-mtf-id="${rightId}"]`);

  const leftRect = leftElement?.getBoundingClientRect();
  const rightRect = rightElement?.getBoundingClientRect();
  const containerRect = containerEl?.getBoundingClientRect();

  const arrow =
    leftRect && rightRect && containerRect
      ? getArrow(
          leftRect.width,
          leftRect.y + leftRect.height / 2 - containerRect.top,
          rightRect.x - containerRect.left,
          rightRect.y + rightRect.height / 2 - containerRect.top,
          {
            bow: 0,
            stretch: 0.1,
            stretchMin: 0,
            stretchMax: 420,
            padStart: 0,
            padEnd: 0,
            flip: false,
            straights: true,
          },
        )
      : null;

  if (!arrow) {
    return null;
  }

  const [sx, sy, cx, cy, ex, ey, ae] = arrow;
  const endAngleAsDegrees = ae * (180 / Math.PI);

  return (
    <svg
      className="pointer-events-none absolute inset-0"
      style={{ width: containerRect?.width, height: containerRect?.height, marginTop: 0 }}
      viewBox={`0 0 ${containerRect?.width} ${containerRect?.height}`}>
      {showDot ? <circle cx={sx} cy={sy} fill={color} r={4} stroke="#fff" strokeWidth={2} /> : null}
      <path
        key={leftId}
        d={`M${sx},${sy} Q${cx},${cy} ${ex},${ey}`}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      {showArrowHead ? (
        <path
          d="M1 1L6 6L1 11"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
          transform={`translate(${ex - 6},${ey - 6}) rotate(${endAngleAsDegrees})`}
        />
      ) : null}
    </svg>
  );
};
